/* Styles */

import "../style/base/_common.scss";
import "../style/components/_utilities.scss";
import "../style/components/_transitions.scss";
import "../style/components/_grid.scss";
import "../style/components/_nav.scss";
import "../style/components/_modal.scss";
import "../style/components/_breadcrumb.scss";
import "../style/components/_buttons.scss";
import "../style/components/_images.scss";
import "../style/components/_forms.scss";
import "../style/components/_box.scss";
import "../style/components/_tooltip.scss";
import "../style/layout/_cookie.scss";
import "../style/layout/_map.scss";
import "../style/layout/_header.scss";
import "../style/layout/_footer.scss";
import "../style/layout/_filters.scss";
import "../style/vendor/_jquery-ui.scss";
import "../style/vendor/_siema.scss";
import "../style/pages/cities.scss";

/* JS */

import "./components/menu";
import "@wikicasa/common/lazy";
import * as Common from "@wikicasa/common/common";

let searchBean: Record<string, any>;

let Filters: any;


$(() => {

    $("#list-dist").on("click", "[data-href]", function () {
        window.location.href = $(this).data("href");
    });

    Common.observe("#filters-form-main", (elem: HTMLElement, observer: IntersectionObserver) => {

        import(/* webpackChunkName: "chunks/filters" */ "./components/filters").then((module: any) => {

            Filters = module;

            Filters.init({
                formMain: "#filters-form-main",
                formMobile: "#filters-form-mobile",
            });


            if (!window["_isAgencyCategory"]) {
                try {
                    searchBean = JSON.parse(window["_serializedSearchBean"]);
                } catch {
                    searchBean = {};
                }
            } else searchBean = {};

            Filters.ready(() => {

                Filters.loadSearch(searchBean);

            });

        });

        observer.disconnect();
    });
});